import styled, { css } from 'styled-components';

export const ModalContent = styled.div`
  position: relative;
  margin: ${({ theme }) => theme.spacing.m};
  z-index: ${({ theme }) => theme.zindex.z30};
`;

export const CloseWrapper = styled.div`
  position: absolute;
  right: -10px;
  top: -10px;
  z-index: 900;
`;

export const ModalChildren = styled.div(
  ({ theme, imageUrl, isFullModal }) => css`
    background: ${theme.colors.white};
    padding: ${theme.spacing.md};
    border-bottom-left-radius: ${theme.radius.s};
    border-bottom-right-radius: ${theme.radius.s};
    border-top-left-radius: ${!imageUrl ? theme.radius.s : ''};
    border-top-right-radius: ${!imageUrl ? theme.radius.s : ''};
    overflow: ${isFullModal ? 'scroll' : 'hidden'};
    max-height: ${isFullModal ? '90vh' : 'auto'};
  `
);

export const Image = styled.div(
  ({ theme, url, isContent }) => css`
    background-image: url(${url});
    background-size: contain;
    background-position: center;
    width: 100%;
    height: 224px;
    border-top-left-radius: ${theme.radius.s};
    border-top-right-radius: ${theme.radius.s};
    border-bottom-right-radius: ${isContent ? 'none' : theme.radius.s};
    border-bottom-left-radius: ${isContent ? 'none' : theme.radius.s};
    background-repeat: no-repeat;
    background-color: ${theme.colors.white};
  `
);

export const ModalWrapper = styled.div`
  position: fixed;
  z-index: 1003;
  width: ${({ theme }) => theme.width.full};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
